// js entry point

import { Notifier } from '@airbrake/browser';
import "@hotwired/turbo-rails"
import "./controllers"
import * as bootstrap from "bootstrap"

// Initialize Airbrake for JavaScript error monitoring
if (window.AIRBRAKE_CONFIG?.projectId) {
  const airbrake = new Notifier({
    projectId: window.AIRBRAKE_CONFIG.projectId,
    projectKey: window.AIRBRAKE_CONFIG.projectKey,
    environment: window.AIRBRAKE_CONFIG.environment
  });

  // Filter out errors from browser extensions
  airbrake.addFilter((notice) => {
    const dominated = notice.errors?.[0]?.backtrace?.some(frame =>
      frame.file?.includes('extension') ||
      frame.file?.includes('chrome-extension') ||
      frame.file?.includes('moz-extension')
    );
    if (dominated) return null;
    return notice;
  });

  // Make available globally for manual error reporting if needed
  window.airbrake = airbrake;
}

window.bootstrap = bootstrap;
window.Modal = bootstrap.Modal;
// could use import { Modal } from "bootstrap" if we only need Modal...
// using Modal and Alert as a minimum...
import 'moment/locale/en-gb.js'
import '@fortawesome/fontawesome-free/css/all.min.css'

// not sure if we will need this
// require("@rails/activestorage").start()

// Fix for Turbo 8 back button bug - see design_notes.md
window.addEventListener("popstate", () => {
  window.location.reload();
});
